module.exports = __webpack_public_path__ + "img/组 9696 .4918631b.png";